import React from "react";

export default function Fourteen({ fill, children }) {
  return (
    <svg
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
      width="300"
      height="300"
      viewBox="0 0 300 300"
    >
      <path d="M75.77,248h5.68A1.59,1.59,0,0,0,83,246.4a1.64,1.64,0,0,0-1.59-1.59h-5.6a1.61,1.61,0,0,0-1.67,1.59A1.59,1.59,0,0,0,75.77,248Z" />
      <polygon points="70.25 272.39 86.88 272.39 86.88 250.33 70.25 250.16 70.25 272.39" />
      <path d="M78.61,273.82a2.24,2.24,0,0,0-2.26,2.25,2.26,2.26,0,1,0,2.26-2.25Z" />
      <path d="M257.1,11.6A11.22,11.22,0,0,0,245.9.4H54.1A11.22,11.22,0,0,0,42.9,11.6v211h0v67.23a9.45,9.45,0,0,0,9.45,9.45h195.3a9.4,9.4,0,0,0,9.45-9.45V222.6h0ZM89.48,257.1v19.22a3.44,3.44,0,0,1-3.43,3.43H71.25a3.45,3.45,0,0,1-3.43-3.43V246.23a3.45,3.45,0,0,1,3.43-3.43h14.8a3.5,3.5,0,0,1,3.43,3.43Zm79.38-34.57-17.45-13.11a2.4,2.4,0,0,0-2.82,0l-17.45,13.11H44.43V11.6A9.68,9.68,0,0,1,54.1,1.93H245.9a9.68,9.68,0,0,1,9.67,9.67V222.53Z" />
      {children}
    </svg>
  );
}
